import React from 'react';
import { useCaliforniaGate } from '../hooks/useCaliforniaGate';

/**
 * Shows the normal site to California visitors, crawlers, and anyone whose
 * location can't be determined. The site renders immediately while the check
 * runs, so allowed visitors see no delay or layout change.
 */
export function GeoGate({
  children
}: {
  children: React.ReactNode;
}) {
  const status = useCaliforniaGate();
  if (status !== 'blocked') return <>{children}</>;
  return <main className="min-h-screen w-full bg-black text-white flex items-center justify-center px-6" data-id="element-195" data-mp="3eb2k2w9jomui">
      <div className="max-w-xl text-center" data-id="element-196" data-mp="39chhiq6tlr2w">
        <p className="text-3xl sm:text-4xl font-black uppercase tracking-tight" data-id="element-197" data-mp="3naz24f1fingl">
          <span className="text-white" data-id="element-198" data-mp="3j7t05jlcnifx">Mike's</span>{' '}
          <span className="text-red-600" data-id="element-199" data-mp="3jaf65esldpw1">Pro Detail</span>
        </p>
        <div className="h-1 w-24 bg-red-600 mx-auto rounded-full my-6" data-id="element-200" data-mp="12idqih0m6j11" />
        <h1 className="text-xl sm:text-2xl font-bold text-gray-200 leading-relaxed" data-id="element-201" data-mp="yimtvwoep8ol">
          Mike’s Pro Detail currently provides mobile detailing services
          throughout California.
        </h1>
      </div>
    </main>;
}